import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { ToastService } from '../services/toast.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router,
    private toastService: ToastService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (!this.authService.isAuthenticated()) {
      return this.router.createUrlTree(['/login']);
    }

    const currentUser = this.authService.getCurrentUser();

    if (!currentUser) {
      return this.router.createUrlTree(['/login']);
    }

    // Usuarios inactivos solo pueden ver Home (que muestra la pantalla de
    // pendiente aprobacion) y Perfil. Cualquier otra ruta los regresa a Home.
    if (currentUser.status === 'inactive') {
      const allowedForInactive = ['/dashboard/home', '/dashboard/profile'];
      const matchesAllowed = allowedForInactive.some(p => state.url.startsWith(p));
      if (matchesAllowed) {
        return true;
      }
      return this.router.createUrlTree(['/dashboard/home']);
    }

    const requiredRoles = route.data['roles'] as string[];
    const requiredTypes = route.data['types'] as string[];

    if (!requiredRoles && !requiredTypes) {
      return true;
    }

    const hasValidRole = !requiredRoles || requiredRoles.includes(currentUser.role);
    const hasValidType = !requiredTypes || requiredTypes.includes(currentUser.type);

    if (hasValidRole && hasValidType) {
      return true;
    }

    this.toastService.show('Access denied. Insufficient privileges.', 'warning');

    if (currentUser.role === 'admin' || currentUser.type === 'god') {
      return this.router.createUrlTree(['/dashboard']);
    } else {
      return this.router.createUrlTree(['/my-reservations']);
    }
  }
}